import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"
import * as DateFns from "date-fns"

export type ListMerchantGroupMerchantsResponseItem = {
  id: string
  merchantName: string
  merchantId: string
  transactionTotal: number
  lastTransactedAt: Date | null
  portalLink: string
  currency: string
  hasDonationsModule: boolean
  hasSalesModule: boolean
  schemaName: string
}

export type ListMerchantGroupMerchantsResponse = {
  merchants: Array<ListMerchantGroupMerchantsResponseItem>
  lastRefreshed: Date
}

const listMerchantGroupMerchants =
  async (): Promise<ListMerchantGroupMerchantsResponse> => {
    const { body } = await api.get<
      RecursivelyConvertDatesToStrings<ListMerchantGroupMerchantsResponse>
    >("/merchant-group/self/merchants/", {
      isMerchantGroup: true,
    })

    const merchants = body.merchants.map((item) => ({
      ...item,
      lastTransactedAt: item.lastTransactedAt
        ? DateFns.parseISO(item.lastTransactedAt)
        : null,
    }))

    return {
      merchants,
      lastRefreshed: DateFns.parseISO(body.lastRefreshed),
    }
  }

export const useMerchantGroupMerchants = () =>
  useQuery({
    queryKey: [BASE_MERCHANT_GROUP_MERCHANTS_QUERY_KEY],
    queryFn: () => listMerchantGroupMerchants(),
  })
